export default __webpack_public_path__ + "static/media/icon_filter_active.8812b39f.svg";